// resetStore.js
import { createAction } from '@reduxjs/toolkit';

export const resetStore = createAction('resetStore');
